import { useState, useEffect } from 'react';

import AnyResultList from "./AnyResultList";

import getNLS from '../../common/_NLS';

export default props => {
	const [propertyType, setType] = useState('hashtag');
	

	const jsx = (<div className="child">
		<style jsx>{`

.child{
	height:0;
	clear:both;
}

.arrow_box {
	position: relative;
	top: 12px;

	box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12);
	border: solid 1px #dee2e6;
	background-color: #ffffff;

	font-size: 14px;
	color: #343a40;
	border-radius: 5px;

	width: 400px;
	height: 300px;
	z-index:2;
}

.arrow_box:after, .arrow_box:before {
	bottom: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.arrow_box:before {
	border-color: rgba(222, 226, 230, 0);
	border-bottom-color: #dee2e6;
	border-width: 7px;
	margin-left: -7px;
}


.arrow_box:after {
	border-color: rgba(255, 255, 255, 0);
	border-bottom-color: #ffffff;
	border-width: 6px;
	margin-left: -6px;
}

span{
	float: left;
}


.item{
	padding: 8px 30px;
	text-align:center;
}


.tabs{
	color: #343a40;
}
.tab{
	width:25%;
	height: 45px;
	font-size: 12px;
	text-align: center;
	color: #adb5bd;

    padding-top: 15px;
	
}
.tab.on{
	color: #343a40;
	border-bottom: solid 1px black;
}


@media all and (max-width:606px) {
  .arrow_box{
    width: 100%;
	text-align: center;

    box-shadow: none;
	border-radius: unset;
	
  }

}

.results-container{
	height: 255px;
	overflow: auto;
}

.closer{
	height:40px;
	line-height: 40px;
	background-color: #343a40;
	color: white;

}

`}</style>

		<div className="arrow_box hiddenable" style={{ display: props.dSearch }}>
			<div className="tabs mouse-aa">
				<div className={"dib tab " + ((propertyType == "hashtag") ? "on" : "")} onClick={() => setType('hashtag')}>{getNLS("해시태그")}</div>
				<div className={"dib tab " + ((propertyType == "brand") ? "on" : "")} onClick={() => setType('brand')}>{getNLS("브랜드")}</div>
				<div className={"dib tab " + ((propertyType == "location") ? "on" : "")} onClick={() => setType('location')}>{getNLS("장소")}</div>
				<div className={"dib tab " + ((propertyType == "user") ? "on" : "")} onClick={() => setType('user')}>{getNLS("사용자")}</div>
			</div>
			<div className="results-container">
				<AnyResultList propertyType={propertyType} keyword={props.keyword} />
			</div>
			{/* <div className="closer dbom" onClick={props.hide}>
				검색 창 끄기
			</div> */}
		</div>


	</div>);
	return (jsx);
}
